import "@/App.css";
import { ReactLenis } from "lenis/react";
import { Toaster } from "@/components/ui/sonner";
import { ConsultationProvider } from "@/components/site/consultation";
import Nav from "@/components/site/Nav";
import Hero from "@/components/site/Hero";
import Marquee from "@/components/site/Marquee";
import ValueProp from "@/components/site/ValueProp";
import Showcase from "@/components/site/Showcase";
import Packages from "@/components/site/Packages";
import WhyChooseUs from "@/components/site/WhyChooseUs";
import HowItWorks from "@/components/site/HowItWorks";
import Faq from "@/components/site/Faq";
import ContactFooter from "@/components/site/ContactFooter";

function App() {
  return (
    <ReactLenis root options={{ lerp: 0.09, smoothWheel: true }}>
      <ConsultationProvider>
        <div className="App bg-bone" id="app-root">
          <Nav />
          <main>
            <Hero />
            <Marquee />
            <ValueProp />
            <Showcase />
            <Packages />
            <WhyChooseUs />
            <HowItWorks />
            <Faq />
            <ContactFooter />
          </main>
          <Toaster position="bottom-right" richColors />
        </div>
      </ConsultationProvider>
    </ReactLenis>
  );
}

export default App;
